import { Dispatch, SetStateAction } from 'react';
import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import {
	runHistoryCheckAwtgRan,
	runHistoryCheckAwtgRanProgress,
} from '@api/hitoryCheck';

import { formatDate } from '@utils/date';
import { handleErrorFromMessage } from '@utils/handleRequestError';

import { TAwtgRanRunDTO } from '@interfaces/cmModule/dto/historyCheckDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EVendorsValues } from '@enums/common';

import { HISTORY_CHECK_AWTG_RAN_RUN_PROGRESS } from '@constants/queryKeys';

type TUseMutateRunHistoryProgressAwtgRanParams = {
	vendor?: string;
	configType?: string;
	networkElementIds?: string[];
	dateFrom?: number;
	dateTo?: number;
	setIsProgressRun: Dispatch<SetStateAction<boolean>>;
};

type TUseMutateRunHistoryProgressAwtgRanReturn = {
	generateProgressId: UseMutateFunction<string, any, void, any>;
	progressId?: string;
};

export const useMutateRunHistoryProgressAwtgRan = (
	params: TUseMutateRunHistoryProgressAwtgRanParams,
): TUseMutateRunHistoryProgressAwtgRanReturn => {
	const {
		vendor,
		configType,
		networkElementIds,
		dateFrom,
		dateTo,
		setIsProgressRun,
	} = params;

	const isAwtgRanVendor = vendor === EVendorsValues.oran;
	const isAwtgRanDtoValid = isAwtgRanVendor && configType && networkElementIds?.length && dateFrom && dateTo;

	const {
		data: progressId,
		mutate: generateProgressId,
	} = useMutation<void, string>({
		mutationKey: [HISTORY_CHECK_AWTG_RAN_RUN_PROGRESS],
		mutationFn: runHistoryCheckAwtgRanProgress,
		onSuccess: async (id) => {
			if (id && isAwtgRanDtoValid) {
				const dto: TAwtgRanRunDTO = {
					configType: configType!,
					from: formatDate(new Date(dateFrom!)),
					networkElementIds: networkElementIds!,
					progressId: id,
					to: formatDate(new Date(dateTo!)),
				};

				await runHistoryCheckAwtgRan(dto);
				setIsProgressRun(true);
			} else {
				setIsProgressRun(false);
			}
		},
		onError: (err: IResponseError) => {
			setIsProgressRun(false);
			handleErrorFromMessage(err);
		},
		enabled: [isAwtgRanVendor],
	});

	return {
		generateProgressId,
		progressId,
	};
};
